/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Row, Col, UncontrolledTooltip, Nav, NavItem } from "reactstrap";

import { NavLink as NavLinkStrap } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import hero8 from "../../assets/images/hero-bg/hero-15.jpg";
import {
  faFacebook,
  faTwitter,
  faYoutube,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";

import {
  signup,
  googleLogin /* resendEmail */
} from "../../actions/auth/authAction";
import SignUpForm from "./SignUpForm";
import Alert from "../../shared/components/Alert";
import VideoPlayer from "../../shared/components/VideoPlayer";

import { openSocialLink } from "../../helpers";

class SignUp extends PureComponent {
  state = {
    isResendEmailOpen: false,
    serverResp: false,
    email: null,
    loading: false,
    success: null,
    error: false,
    errorType: null
  };
  resetForm;
  onFormSubmit = (values, resetForm) => {
    this.resetForm = resetForm;
    this.setState({
      email: values.email,
      loading: true,
      success: null,
      error: null,
      errorType: null
    });
    this.props.signup(values);
  };

  onSocialLogin = response => {
    this.props.googleLogin(response.tokenObj.id_token);
  };

  handleResendEmail = e => {
    e.preventDefault();
    this.setState({
      loading: true,
      success: null,
      error: null,
      errorType: null
    });
    if (this.state.email) {
      this.props.resendEmail(this.state.email);
    }
  };

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.history.push("/");
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.auth.isSignupSuccess === true) {
      if (nextProps.auth.isAuthenticated) {
        nextProps.history.push("/");
      } else if (nextProps.auth.loginSuccess === false) {
        return {
          loading: false,
          error: nextProps.auth.error,
          errorType: nextProps.auth.type,
          redirectTo: "/"
        };
      }
    } else if (nextProps.auth.isSignupSuccess === false) {
      return { loading: false, error: nextProps.auth.message };
    } else if (nextProps.auth.isAuthenticated) {
      nextProps.history.push("/");
    }

    return null;
  }

  render() {
    let alertContent;
    if (this.state.error) {
      alertContent = (
        <Alert color="danger" className="alert--bordered" icon>
          <p>{this.state.error}</p>
        </Alert>
      );
    } else if (this.state.success) {
      alertContent = (
        <Alert color="success" className="alert--bordered" icon>
          <p>{this.state.success}</p>
          {/* <br /> */}
          {/* <a href="/" onClick={this.handleResendEmail}>Resend verification email</a> */}
        </Alert>
      );
    }

    return (
      <div className="app-wrapper login-screen min-vh-100 bg-white">
        <div className="app-main min-vh-100">
          <div className="app-content p-0">
            <div className="app-inner-content-layout--main">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content">
                  <Row className="min-vh-100 no-gutters">
                    <Col lg="7" xl="6" className="d-flex align-items-center">
                      <Col md="10" lg="8" xl="8" className="mx-auto">
                        {alertContent}
                        <SignUpForm
                          onSubmit={this.onFormSubmit}
                          onSocialLogin={this.onSocialLogin}
                          loading={this.state.loading}
                          location={this.props.location}
                        />
                      </Col>
                    </Col>
                    <Col lg="5" xl="6" className="d-flex">
                      <div className="hero-wrapper w-100 bg-composed-wrapper bg-premium-dark min-vh-lg-100">
                        <div className="flex-grow-1 w-100 d-flex align-items-center">
                          <div
                            className="bg-composed-wrapper--image opacity-5"
                            style={{ backgroundImage: "url(" + hero8 + ")" }}
                          />
                          <div className="bg-composed-wrapper--bg bg-second opacity-6" />
                          <div className="bg-composed-wrapper--bg bg-deep-blue opacity-2" />
                          <div className="bg-composed-wrapper--content text-center p-5">
                            <div className="text-white px-0 px-lg-2 px-xl-4">
                              <h1 className="display-3 mb-4 font-weight-bold">
                                Take control of your real estate investments
                              </h1>
                              <p className="display-4 mb-0 opacity-8">
                                BetterCapital.us is a great, easy way to keep
                                track of all your investments, whether they're
                                paying off or not.
                              </p>
                              <div className="divider mx-auto border-1 my-5 border-light opacity-2 rounded w-25" />
                              <VideoPlayer
                                url={
                                  "https://www.youtube.com/watch?v=TA-W___W7ac"
                                }
                                ctaBtnColor="success"
                                ctaBtnLabel="Intro"
                                ctaBtnTag="button"
                                className="px-5 font-size-sm font-weight-bold btn-animated-icon text-uppercase rounded shadow-none py-3 hover-scale-sm hover-scale-lg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="hero-footer pb-4">
                          <Nav pills className="nav-neutral-secondary">
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("facebook")}
                                className="font-size-lg text-white-50"
                                id="FacebookTooltipExample7"
                              >
                                <FontAwesomeIcon icon={faFacebook} />
                              </NavLinkStrap>
                              <UncontrolledTooltip
                                target="FacebookTooltipExample7"
                                container="body"
                              >
                                Facebook
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("twitter")}
                                className="font-size-lg text-white-50"
                                id="btnTwitterTooltip"
                              >
                                <FontAwesomeIcon icon={faTwitter} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnTwitterTooltip">
                                Twitter
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("youtube")}
                                className="font-size-lg text-white-50"
                                id="btnGoogleTooltip"
                              >
                                <FontAwesomeIcon icon={faYoutube} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnGoogleTooltip">
                                Google
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("instagram")}
                                className="font-size-lg text-white-50"
                                id="btnInstagramTooltip"
                              >
                                <FontAwesomeIcon icon={faInstagram} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnInstagramTooltip">
                                Instagram
                              </UncontrolledTooltip>
                            </NavItem>
                          </Nav>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.login
});

const mapDispatchToProps = dispatch => ({
  signup: userData => {
    signup(userData, dispatch);
  },
  googleLogin: token => {
    googleLogin(token, dispatch);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SignUp));
